import React from 'react'
import port1 from '../assets/port1.png';
import port2 from '../assets/port2.png';
import port3 from '../assets/port3.png';
import port4 from '../assets/port4.png';
import port5 from '../assets/port5.png';
import port6 from '../assets/port6.png';
import port7 from '../assets/port7.png';
import port8 from '../assets/port8.png';
import Marquee from "react-fast-marquee";
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, {
    Autoplay
} from 'swiper';
import { EffectFade } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';


SwiperCore.use([Autoplay]);

const Hero = () => {

    React.useEffect(() => {
        var pix = document.querySelectorAll(".pixel");
        pix.forEach(e => {
            e.style.animationDelay = Math.ceil(Math.random()*5000)+"ms";
        });
    }, [])
    
    const [activeSlider, setActiveSlider] = React.useState(0)

    const renderSwitch = (p) => {
        switch(p) {
            case 2:
                return 'orange';
            case 3:
                return 'red';
            case 4:
                return 'cel';
            case 5:
                return 'cel';
            case 6:
                return 'blue';
            case 7:
                return 'yellow';
            case 8:
                return 'tur';
            default:
                return '';
        }
      }
   
    return (
        <div className={`hero flex flexcol centerflex vertcenter relative ${renderSwitch(activeSlider)}`} >
            <div className="sidePanel">
            <div className={`pixelCon ${renderSwitch(activeSlider)}`}>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
                <div className="pixel"></div>
            </div>
            </div>
            <h1 className='relative'>Baby Pixel Gator</h1>
            <Marquee
            className='swiperText'
            speed={90}
            gradient={false}
            >
            <span> - Evolution is a must</span>
            <span> - Evolution is a must</span>
            <span> - Evolution is a must</span>

            </Marquee>

            <Swiper
                modules={[EffectFade]} effect="fade"
                slidesPerView={1}
                pagination={false}
                speed={1000}
                centeredSlides={true}
                grabCursor={false}
                loop={true}
                onSlideChange={(swiper) => setActiveSlider(swiper.activeIndex)}
                autoplay={{
                    "delay": 1000,
                    "disableOnInteraction": false
                }}
                className='sliderHero'
                >
                <SwiperSlide>
                        <img src={port1} className='relative' alt="Port 1" />
                </SwiperSlide>
                <SwiperSlide>
                        <img src={port2} className='relative' alt="Port 2" />
                </SwiperSlide>
                <SwiperSlide>
                        <img src={port3} className='relative' alt="Port 3" />
                </SwiperSlide>
                <SwiperSlide>
                        <img src={port4} className='relative' alt="Port 4" />
                </SwiperSlide>
                <SwiperSlide>
                        <img src={port5} className='relative' alt="Port 5" />
                </SwiperSlide>
                <SwiperSlide>
                        <img src={port6} className='relative' alt="Port 6" />
                </SwiperSlide>
                <SwiperSlide>
                        <img src={port7} className='relative' alt="Port7" />
                </SwiperSlide>
                <SwiperSlide>
                        <img src={port8} className='relative' alt="Port 8" />
                </SwiperSlide>

                </Swiper>
                <div className="buttons flex flexrow centerflex vertcenter relative">
                    <a className='btn disc' target='_blank' href="https://discord.gg/meFFTfkdRh" rel="noreferrer" >Discord</a>
                    <a className='btn twit' target='_blank' href="https://twitter.com/BabyPixelGator" rel="noreferrer" >Twitter</a>
                    <a className='btn buy' target='_blank' href="https://61ca24b22738da3d4a6fdba5--bpgmint.netlify.app">Mint</a>
                    <a className='btn disc' href="#">Magic Eden</a>
                </div>

        </div>
    )
}

export default Hero
